import byPosition from './by_position';
import Data from '../data.js.erb';

export default function (federalDistrictId) {
  const regions = Data.regions.filter(region => region.federal_district_id === parseInt(federalDistrictId));
  return regions.sort(byPosition)
}
